import { useSelector } from 'react-redux';
import { selectAccessToken, selectIsLoggedIn } from 'redux/users/selectors';
import { Loadable } from 'utils/ComponentLoader';
import AuthRedirect from './AuthRedirect';

const Dashboard = Loadable(() => import('pages/Dashboard'), 'dashboard');

const PrivateDashboard = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const accessToken = useSelector(selectAccessToken);
  const auth = !!(isLoggedIn && accessToken);
  return auth ? <Dashboard /> : <AuthRedirect />;
};

export default PrivateDashboard;
